export function formatAmount(
  value?: number | string | null,
  options: Partial<Intl.NumberFormatOptions> = {},
): string | null {
  if (value === undefined || value === null) {
    return "–";
  }

  const floatNum = typeof value === "string" ? parseFloat(value) : value;

  if (Number.isNaN(floatNum)) {
    return "–";
  }

  return new Intl.NumberFormat("en-US", { ...options }).format(floatNum);
}
